const OFFERS_LOADING = "OFFERS_LOADING";
const OFFERS_SUCCESS = "OFFERS_SUCCESS";
const OFFERS_ERROR = "OFFERS_ERROR";

export {
    OFFERS_LOADING,
    OFFERS_ERROR,
    OFFERS_SUCCESS,
};